import { Display } from '@/components/Display/Display';
// import WebReference from '@/pages/Web/PageComponents/UsualSkill/Reference';
import WebReference from '@/pages/Web/PageComponents/WebReference';
import MobileReference from '@/pages/Mobile/PageComponents/UsualSkill/Reference';
const References = (props) => {
    return (
        <>
            <Display show={props.side === 'web'}>
                <WebReference {...props} />
            </Display>
            <Display show={props.side === 'mobile'}>
                <MobileReference {...props} />
            </Display>
        </>
    );
};

export default References;
